export default {
  title: {
    step1Request: 'Solicitud',
    step1Identity: 'Identificación',
    redirect: 'Redirigiendo',
    step2: 'Operación',
    step3: 'Resumen',
    step3Confirm: 'Confirmación datos',
    step4Ok: 'Terminado',
    step4Ko: 'Proceso interrumpido',
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos'
    },
    study: {
      title: '<h1>Operación en estudio...</h1>',
      title2: '<h2>Nuestro equipo analizará tu solicitud de forma manual</h2>',
      text: '<p>Te enviaremos un email con el resultado una vez finalicemos el estudio manual.</p>',
      text2:
        '<b>Para agilizar el proceso, por favor incorpora más abajo la documentación requerida para realizar el análisis manual.</b>',
      response:
        '<b>¡Gracias!</b></br>Tu documentación ha sido remitida y contactaremos antes de 48 horas laborables con el resultado del análisis de su operación.</br>Para cualquier duda, póngase en contacto con tu agente comercial.'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAcceptRecord: 'Aceptar y Grabar',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnDownload: 'Descargar',
      btnPreContractualInfo: 'Información precontractual',
      btnTelephone: '910 554 977',
      btnEmail: 'campanas@bbvaautorenting.es'
    },
    label: {
      renovation: 'Renovación',
      congratulations: '¡Enhorabuena',
      textFinish: 'Tu proceso ha terminado'
    },
    placeholder: {
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      financialIncomes: 'Ingresos Mensuales',
      antiquity: 'Antigüedad',
      dateRetirement: 'Fecha jubilación',
      companyNameLast: 'Nombre de última empresa',
      dateRegistration: 'Fecha alta IAE',
      companyExercise: 'Actividad (Indicar código CNAE)',
      companyName: 'Nombre de la empresa',
      dealerCode: 'Código de gestor',
      name: 'Nombre',
      surname: 'Primer apellido',
      surname2: 'Segundo apellido',
      documentTypes: 'Tipo de documento',
      documentId: 'Número {document}',
      documentIdGlobal: 'Número de documento (DNI, NIE)',
      businessName: 'Razón social',
      cif: 'CIF',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      issueDate: 'Fecha de emisión',
      plateNumber: 'Matricula'
    }
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe'
  },
  success: {}
};
